import jQuery from 'jquery';
import {mainSlider,  top_swiper } from './swiper';

let slider_anim_toggle = 0;
// if (popstateFlag === 1) {
// }
let current_data = 0;

// let current_link = link_array.default_op.json;
let loop_anime_flag = 0;
let thmb_cli_flag = 0;
let pjax_anim_flag = 0;
let pjax_anim_02_flag = 0;
let pjax_anim_ = 0;

export const page_anime_func = () => {
	//ページ遷移アニメーション
	console.log('page_anime_func');
	
	
};

//topページ スライダー周りモジュール
export const slider_top = () => {
	// console.log('slider_anim_01',mainSlider);
	
	top_swiper();
	$('.js-first-slide').addClass('anm-started js-circle-active');
	
	
	// $('.swiper_pager-container').css('opacity', 1);
	// current_data = $('.sw-slide-active').data('link');
	// current_link = link_array[current_data]['json'];
	// $('.op_anim').remove();
	// $('body').removeClass('js-opening_anim-active');
	// $('body').addClass('js-slide-visible');
	// loop_anime_flag = 0;

	// $('.top_slider').addClass('pj');
	// set_remove = setTimeout(() => {
	// 	$('.top_slider').removeClass('pj');
	// }, 4450);
	// loop_ring_wrap.addEventListener('complete', (e) => {//page_anime_func
	// 	if (slider_anim_toggle == 0) {
	// 		if ($('.ttl_anim').length) {
	// 			$('.ttl_anim').remove();
	// 		}
	// 		if (thmb_cli_flag == 0) {
	// 			current_data = $('.sw-slide-active').next().data('link');
	// 			if (current_data == undefined) {
	// 				current_data = 'slider_num_01';
	// 			}
	// 			current_link = link_array[current_data]['json'];
	// 		}
	// 		slider_ttl_anim(0);
	// 		// loop_ring_wrap.goToAndPlay(0, 1);
	// 		mySwiper.slideNext();
	// 	}
	// 	if (thmb_cli_flag == 1) {
	// 		thmb_cli_flag = 0;
	// 	}
	// 	if (loop_anime_flag == 1) {
	// 		loop_anime_flag = 0;
	// 	}
	// });
};

export const slider_ttl_anim = (startF) => {
	console.log('slider_ttl_anim');

	// if ($('#ttl_anim_wrap').length) {
	// 	lottie.setQuality(10);
	// 	var lottie_option = {
	// 		container: document.getElementById('ttl_anim_wrap'),
	// 		renderer: 'svg',

	// 		path: 'assets/js/json/' + current_link,
	// 		rendererSettings: {
	// 			className: 'ttl_anim',
	// 		},
	// 	};
	// 	var ttl_anim_wrap = lottie.loadAnimation(lottie_option);
	// 	ttl_anim_wrap.goToAndPlay(startF, true);
	// 	if (slider_anim_toggle == 'off') {
	// 		ttl_anim_wrap.addEventListener('DOMLoaded', function () {
	// 			ttl_anim_wrap.goToAndStop(startF, true);
	// 		});
	// 	}
	// 	if (pjclick == 1) {
	// 		ttl_anim_wrap.addEventListener('DOMLoaded', function () {
	// 			ttl_anim_wrap.goToAndStop(startF, true);
	// 		});
	// 	}
	// }
};

export const ttl_pjax_anim = (startF) => {
	console.log('ttl_pjax_anim');

	// if ($('#ttl_pjax_anim_wrap').length) {
	// 	var ttl_anim_option = {
	// 		container: document.getElementById('ttl_pjax_anim_wrap'),
	// 		renderer: 'svg',
	// 		path: 'assets/js/json/' + current_link,
	// 		rendererSettings: {
	// 			className: 'ttl_pjax_anim',
	// 		},
	// 	};
	// 	lottie.setQuality(10);
	// 	var ttl_pjax_anim__ = lottie.loadAnimation(ttl_anim_option);

	// 	if (pjclick == 1) {
	// 		ttl_pjax_anim__.addEventListener('DOMLoaded', function () {
	// 			ttl_pjax_anim__.goToAndStop(startF, true);
	// 			setTimeout(() => {
	// 				$('.ttl_anim').remove();
	// 			}, 500);
	// 		});
	// 	}
	// }
};

export const pjax_anim_01 = (startF) => {
	console.log('pjax_anim_01');

	// $('body').addClass('js-pjax_anim-active');
	// var lottie_option = {
	// 	container: document.getElementById('next_page_wrap'),
	// 	renderer: 'svg',
	// 	autoplay: false,
	// 	path: 'assets/js/json/' + json_array.pjax_anim_01,
	// 	rendererSettings: {
	// 		className: 'next_page',
	// 	},
	// };
	// lottie.setQuality(10);
	// var pjax_anim = lottie.loadAnimation(lottie_option);
	// if (pjax_anim_flag == 1) {
	// 	pjax_anim.goToAndPlay(30, true);
	// 	pjax_anim.addEventListener('complete', (e) => {
	// 		pjax_anim_flag = 0;
	// 	});
	// }
	// if (pjax_anim_flag == 0) {
	// 	pjax_anim.goToAndPlay(startF, true);
	// }
	// pjax_anim.addEventListener('complete', (e) => {
	// 	setTimeout(() => {
	// 		pjax_anim.destroy();
	// 		$('body').removeClass('js-pjax_anim-active');
	// 	}, 450);
	// });
};

export const pjax_anim_ringOpen = (startF) => {
	console.log('pjax_anim_ringOpen');

	// $('body').addClass('js-pjax_anim-active');
	// var lottie_option = {
	// 	container: document.getElementById('pjax_anim_wrap'),
	// 	renderer: 'svg',
	// 	autoplay: false,
	// 	path: 'assets/js/json/' + json_array.pjax_anim_ringOpen,
	// 	rendererSettings: {
	// 		className: 'pjax_anim',
	// 	},
	// };
	// lottie.setQuality(10);
	// var ringOpen = lottie.loadAnimation(lottie_option);
	// if (pjax_anim_flag == 1) {
	// 	ringOpen.goToAndPlay(30, true);
	// 	ringOpen.addEventListener('complete', (e) => {
	// 		pjax_anim_flag = 0;
	// 	});
	// }
	// if (pjax_anim_flag == 0) {
	// 	ringOpen.goToAndPlay(startF, true);
	// }
	// ringOpen.addEventListener('complete', (e) => {
	// 	$('body').removeClass('js-pjax_anim-active');
	// 	ringOpen.destroy();
	// });
};

export const pjax_anim_02 = () => {
	console.log('pjax_anim_02');

	// $('body').removeClass('non-scrollable');
	// $('body').removeClass('js-pjax_anim_02-active');
	// if ($('#page_sub').length) {
	// 	var lottie_option = {
	// 		container: document.getElementById('pjax_anim_02_wrap'),
	// 		renderer: 'svg',
	// 		autoplay: true,
	// 		path: 'assets/js/json/' + json_array.pjax_anim_02,
	// 		rendererSettings: {
	// 			className: 'pjax_anim_02',
	// 		},
	// 	};
	// 	lottie.setQuality(10);
	// 	if (pjax_anim_02_flag == 0) {
	// 		pjax_anim_ = lottie.loadAnimation(lottie_option);
	// 		pjax_anim_.addEventListener('DOMLoaded', function () {
	// 			pjax_anim_.pause();
	// 		});
	// 	}
	// 	if (pjax_anim_02_flag == 1) {
	// 		pjax_anim_.play();
	// 		pjax_anim_02_flag = 0;
	// 		pjax_anim_.addEventListener('complete', (e) => {
	// 			$('body').removeClass('non-scrollable');
	// 			$('body').removeClass('js-pjax_anim_02-active');
	// 			$('body').removeClass('js-subpage_openring-active');
	// 		});
	// 	}
	// }
};

// cvボタンのアニメーション
export const scroll_icon = () => {
	console.log('scroll_icon');

	// var lottie_option = {
	// 	name: scroll,
	// 	container: document.getElementById('scroll_icon'),
	// 	renderer: 'svg',
	// 	loop: true,
	// 	path: 'assets/js/json/' + json_array.scroll_icon,
	// 	rendererSettings: {
	// 		className: 'scroll_icon_svg',
	// 	},
	// };
	// lottie.setQuality(10);
	// let scroll_icon_anim = lottie.loadAnimation(lottie_option);
};
export const scroll_icon_02 = () => {
	console.log('scroll_icon_02');
	// var lottie_option = {
	// 	name: scroll,
	// 	container: document.getElementById('scroll_icon_02'),
	// 	renderer: 'svg',
	// 	loop: true,
	// 	path: 'assets/js/json/' + json_array.scroll_icon,
	// 	rendererSettings: {
	// 		className: 'scroll_icon_svg',
	// 	},
	// };
	// lottie.setQuality(10);
	// let scroll_icon_anim = lottie.loadAnimation(lottie_option);
};
